import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { IEmployeeShortSave } from '@app/components/employee-form/interfaces/iemployee-form';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  private BASE_URL_SERVICE: string = environment.endpoint.apiemployee;

  constructor(private http: HttpClient) { }

  sendResume(req: { _idEmployee: any; institutionList: number[]; }) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'sendResume/', req);
  }

  searchTalent(req: any) {
    return this.http.post(this.BASE_URL_SERVICE + 'searchTalent/', req);
  }

  getLeadDetail(token: string) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'facebookLead/' + `${token}`);
  }

  setEmployeeFavorite(vIdEmployee: any, vIdEmployer: any, vEmployeeFavorite: any) {

    var req = {
      _idEmployee: vIdEmployee,
      _idEmployer: vIdEmployer,
      employeeFavorite: vEmployeeFavorite
    }

    return this.http.post(this.BASE_URL_SERVICE + 'setEmployeeFavorite/', req);
  }

  getValidProfile(_id: any) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'getValidProfile/' + `${_id}`);
  }
  getValidProfileApplication(_idEmployee: any, _idJob) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'getValidProfileApplication/', { _idEmployee, _idJob });
  }

  getValidationResume(_id: any) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'getValidationResume/' + `${_id}`);
  }

  getEmployeeProfile(_id: any) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'getEmployeeProfile/' + `${_id}`);
  }

  getEmployeeByToken(token: string) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'getEmployeeByToken/' + `${token}`);
  }

  getEmployeeProfileConfig(_id: any) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'getEmployeeProfileConfig/' + `${_id}`);
  }

  getEmployeeDetails(_idEmployee: number, _idEmployer: number, _idUser: any, _idJob: any) {

    let req = {
      _idEmployee: _idEmployee,
      _idEmployer: _idEmployer,
      _idUser: _idUser,
      _idJob: _idJob,

    };

    return this.http.post(this.BASE_URL_SERVICE + 'getEmployeeDetails/', req);
  }

  createEmployeeShort(req: IEmployeeShortSave) {

    if (req._idUser > 0) {
      return this.http.put<any>(this.BASE_URL_SERVICE + 'updateEmployeeShort', req);
    }

    return this.http.post<any>(this.BASE_URL_SERVICE + 'createEmployeeShort', req);
  }

  postEmployeePreferences(req: any) {

    return this.http.post<any>(this.BASE_URL_SERVICE + 'postEmployeePreferences/', req);
  }

  postEmployeeNote(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'postNote/', req);
  }

  postEmployeePriority(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'postPriority/', req);
  }

  deleteEducation(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'deleteEducation/', req);
  }

  deleteExperience(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'deleteExperience/', req);
  }

  deleteSubject(_id: string) {
    return this.http.delete<any>(this.BASE_URL_SERVICE + 'deleteSubject/' + `${_id}`)
  }


  deleteAward(_id: string) {
    return this.http.delete<any>(this.BASE_URL_SERVICE + 'deleteAward/' + `${_id}`)
  }

  deleteReference(_id: string) {
    return this.http.delete<any>(this.BASE_URL_SERVICE + 'deleteReference/' + `${_id}`)
  }

  deleteLanguage(_id: string) {
    return this.http.delete<any>(this.BASE_URL_SERVICE + 'deleteLanguage/' + `${_id}`)
  }

  deleteTraining(_id: string) {
    return this.http.delete<any>(this.BASE_URL_SERVICE + 'deleteTraining/' + `${_id}`)
  }

  putEmployeeProfileValid(_id: string, req: any) {
    return this.http.put<any>(this.BASE_URL_SERVICE + `putEmployeeProfileValid/${_id}`, req)
  }

  putEmployeeProfile(_id: string, req: any) {
    return this.http.put<any>(this.BASE_URL_SERVICE + `putEmployeeProfile/${_id}`, req)
  }

  putEmployeeProfileApplication(_id: string, req: any) {
    return this.http.put<any>(this.BASE_URL_SERVICE + `putEmployeeProfileApplication/${_id}`, req)
  }

  saveExperience(_id: number, req: any) {

    if (_id > 0) {
      return this.http.put<any>(this.BASE_URL_SERVICE + `putExperience/${_id}`, req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'postExperience/', req);
    }
  }

  postInstitutionReview(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'postInstitutionReview/', req);
  }

  saveSalary(_id: number, req: any) {

    if (_id > 0) {
      return this.http.put<any>(this.BASE_URL_SERVICE + `putSalary/${_id}`, req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'postSalary/', req);
    }
  }

  postSalaryException(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'postSalaryException/', req);
  }

  saveEducation(_id: number, req: any) {

    if (_id > 0) {
      return this.http.put<any>(this.BASE_URL_SERVICE + `putEducation/${_id}`, req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'postEducation/', req);
    }
  }

  saveLanguage(_id: number, req: any) {

    if (_id > 0) {
      return this.http.put<any>(this.BASE_URL_SERVICE + `putLanguage/${_id}`, req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'postLanguage/', req);
    }
  }

  saveTraining(_id: number, req: any) {

    if (_id > 0) {
      return this.http.put<any>(this.BASE_URL_SERVICE + `putTraining/${_id}`, req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'postTraining/', req);
    }
  }


  saveAward(_id: number, req: any) {

    if (_id > 0) {
      return this.http.put<any>(this.BASE_URL_SERVICE + `putAward/${_id}`, req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'postAward/', req);
    }
  }

  saveReference(_id: number, req: any) {

    if (_id > 0) {
      return this.http.put<any>(this.BASE_URL_SERVICE + `putReference/${_id}`, req);
    }
    else {
      return this.http.post<any>(this.BASE_URL_SERVICE + 'postReference/', req);
    }
  }

  validateReferenceToken(token: string) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'validateReferenceToken/' + `${token}`);
  }

  validateReference(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'validateReference/', req);
  }

  draftReference(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'draftReference/', req);
  }

  resendReferenceToken(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'resendReferenceToken/', req);
  }

  postFile(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'postFile/', req);
  }

  postSubstitutionRange(value: any, values: any[]) {

    let req = {
      idEmployee: value,
      range: values
    }

    return this.http.post(environment.endpoint.apiemployee + 'postSubstitutionRange/', req);
  }

  postEmployeeSubtitution(_idUser: number, _idEmployee: number, employeeSubstitution: number) {

    let req = { _idUser, _idEmployee, employeeSubstitution }

    return this.http.post(environment.endpoint.apiemployee + 'postEmployeeSubtitution/', req);
  }

  getEmployeeProfileSubstitution(_id: any) {
    return this.http.get<any>(this.BASE_URL_SERVICE + 'getEmployeeProfileSubstitution/' + `${_id}`);
  }

  deleteFile(req: any) {
    return this.http.post<any>(this.BASE_URL_SERVICE + 'deleteFile/', req);
  }

  getInterview(_idUser: number, _idInterview: number, _idEmployer: number) {

    const req = { _idUser, _idInterview, _idEmployer };

    return this.http.post(this.BASE_URL_SERVICE + 'getInterview/', req);
  }

}
